const BingoDropdown = () => {
    return {
        open: false,
        text: 'Select...',
        value: '',
        options: [],

        toggle() {
            this.open = !this.open;
        },

        close() {
            this.open = false;
        },

        click(option) {
            if (option.disabled) {
                return;
            }

            this.$refs.select.value = option.value;
            this.value = option.textContent;
            this.text = option.textContent;

            this.$refs.select.dispatchEvent(new Event('change', { bubbles: true }));
            this.close();
        },

        isSelected(option) {
            return option.value === this.value;
        },

        optionClasses(option) {
            if (this.isSelected(option)) {
                return 'font-bold bg-secondary-500 text-white rounded-md';
            }
            return 'text-neutral-900 hover:bg-secondary-500 hover:text-white';
        },

        optionStatus(option) {
            if (this.isSelected(option)) {
                return 'text-white font-bold';
            }
            return option.disabled ? 'text-neutral-400' : 'text-neutral-700 group-hover:text-white';
        },

        borderClasses() {
            return this.open ? 'border-secondary-500' : 'border-neutral-200';
        },

        getSelectedOption() {
            return this.options.length > 0 ? this.options[this.$refs.select.selectedIndex] : {};
        },

        update() {
            this.value = this.$event.detail;
        },

        refreshOptions() {
            this.options = [];
            setTimeout(() => {
                this.options = this.$refs.select.children;
                const selectedOption = this.getSelectedOption();
                this.text = selectedOption?.text;
            }, 250);
        },

        init() {
            this.options = this.$refs.select.children;
            this.value = this.$refs.select.value;

            const selectedOption = this.getSelectedOption();
            this.text = selectedOption?.text;

            this.$refs.select.addEventListener('change', (e) => {
                this.close();
            });

            this.$watch('value', (value, oldValue) => {
                if (oldValue === undefined || value === oldValue) return;
                const selected = this.getSelectedOption();
                this.text = selected?.text;
            });

            setTimeout(() => {
                this.$refs.select.dispatchEvent(new Event('change', { bubbles: true }));
            }, 100);
        }
    }
}

export default BingoDropdown;
